export const MenuKeys = {
  InternshipOffers: 'InternshipOffers',
  InternshipProcesses: 'InternshipProcesses',
  RegisterOrganization: 'RegisterOrganization',
  WorkReport: 'WorkReport',
  Students: 'Students',
  ResearchAgrements: 'ResearchAgrements',
  ResearchAgrementsForUniversityCoordonator:
    'ResearchAgrementsForUniversityCoordonator',
  StudentEvaluationSupervisor: 'StudentEvaluationSupervisor',
  Docs: 'Docs',
  SummaryTableSupervisor: 'SummaryTableSupervisor',
  StudentAssign: 'StudentAssign',
  RegisteredOrganizations: 'RegisteredOrganizations',
  ReprezentativeOrganization: 'ReprezentativeOrganization',
  ManageInternshipsOrganizationRepresentative:
    'ManageInternshipsOrganizationRepresentative',
  ManageSupervisors: 'ManageSupervisors',
  SupervisorAssign: 'SupervisorAssign',
  OrganizationsLegalDepartment: 'OrganizationsLegalDepartment',
  Conventions: 'Conventions',
  OrganizationsRector: 'OrganizationsRector',
  ManageInternshipsRector: 'ManageInternshipsRector',
  CreateUniversity: 'CreateUniversity',
  ManageUnuversityMembers: 'ManageUniversityMembers',
  UniversityOrganizationRegistration: 'UniversityOrganizationRegistration',
  CompetencyTable: 'CompetencyTable',
  ResearchAgreement: 'ResearchAgreement',
  StudyYear: 'StudyYear',
  ProcessStartSettings: 'ProcessStartSettings',
  RepresentativeDocs: 'RepresentativeDocs',
} as const;

export const MenuGroups = {
  Administrator: 'Administrator',
  Supervisor: 'Supervisor',
  UniversityReprezentative: 'UniversityReprezentative',
  LegalDepartment: 'LegalDepartment',
  Rector: 'Rector',
  Tutor: 'Tutor',
  OrganizationRepresentative: 'OrganizationRepresentative',
  General: 'General',
  Student: 'Student',
  UniversityCoordonator: 'UniversityCoordonator',
} as const;
